import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GrantPassword } from  "../models/api_models/grantPassword"

import { AutorizationService } from '../api/autorization.service';
@Component({
  selector: 'app-user-authorization',
  templateUrl: './user-authorization.component.html',
  styleUrls: ['./user-authorization.component.less']
})
export class UserAuthorizationComponent implements OnInit {

  grant:GrantPassword;
  startDate = new Date(1990, 0, 1);


  constructor(private autorizationService : AutorizationService) {
    
    this.grant = new GrantPassword();
   }

  ngOnInit() {
  }

  login() {
    // conslog(this.grant);
    this.autorizationService.login(this.grant);
}

}
